<script setup lang="ts">
import {$t} from "../ts/translations";
import {computed} from "vue";

const props = defineProps(['passwordRules'])

const anyRules = computed(() => {
  // small trick to check if any of the password rules are either "true" or > 0
  return Object.values(props.passwordRules).some(rule => rule);
});
</script>

<template>
  <section class="has-text-left content" data-test-id="password-rules" v-if="anyRules">
    <p class="mb-1">{{$t('new_password_rules')}}:</p>
    <ul>
      <li v-if="passwordRules.minLength > 0">{{$t('new_password_minLength')}}: {{passwordRules.minLength}}</li>
      <li v-if="passwordRules.letters">{{$t('new_password_letters')}}</li>
      <li v-if="passwordRules.specialChars">{{$t('new_password_specialChars')}}</li>
      <li v-if="passwordRules.lowerUpperCase">{{$t('new_password_lowerUpperCase')}}</li>
      <li v-if="passwordRules.digits">{{$t('new_password_digits')}}</li>
    </ul>
  </section>
</template>

<style scoped>
</style>
